import React from 'react';
import { Modal, Form, Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { AntdButton,InputField } from '../../blueplanitUtils/InputField';
const CreateItemModal = ({
  isVisible,
  modalType,
  loading,
  onClose,
  onSubmit,
  form
}) => {
  const getModalTitle = () => {
    switch (modalType) {
      case 'page': return 'Create New Page';
      case 'dropdown': return 'Create New Dropdown';
      case 'option': return 'Create New Option';
      default: return 'Create New Item';
    }
  };

  const getModalPlaceholder = () => {
    switch (modalType) {
      case 'page': return 'Enter page name (e.g., Product Management, User Settings)';
      case 'dropdown': return 'Enter dropdown name (e.g., Categories, Brands, Status)';
      case 'option': return 'Enter option name (e.g., Electronics, Active, Premium)';
      default: return 'Enter name';
    }
  };

  const handleCancel = () => {
    if (!loading) {
      onClose();
      form.resetFields();
    }
  };

  return (
    <Modal
      title={getModalTitle()}
      visible={isVisible}
      onCancel={handleCancel}
      footer={null}
      width={400}
      closable={!loading}
      maskClosable={!loading}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        initialValues={{ name: '' }}
      >
        <Form.Item
          label={`${modalType.charAt(0).toUpperCase() + modalType.slice(1)} Name`}
          name="name"
          rules={[{ required: true, message: `Please input the ${modalType} name!` }]}
        >
          <InputField
            placeholder={getModalPlaceholder()}
            disabled={loading}
          />
        </Form.Item>

        <Form.Item>
          <div style={{ display: 'flex', gap: '8px' }}>
            <AntdButton 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              style={{ flex: 1 }}
              icon={loading ? <Spin size="small" /> : <FontAwesomeIcon icon={faPlus} />}
            >
              {loading ? 'Creating...' : `Create ${modalType.charAt(0).toUpperCase() + modalType.slice(1)}`}
            </AntdButton>
            
            <AntdButton 
              onClick={handleCancel}
              disabled={loading}
              icon={<FontAwesomeIcon icon={faXmark} />}
            >
              Cancel
            </AntdButton>
          </div>
        </Form.Item>
      </Form>
      
      {/* Loading overlay for modal */}
      {loading && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          borderRadius: '6px'
        }}>
          <div style={{ textAlign: 'center' }}>
            <Spin size="large" />
            <div style={{ marginTop: '8px', color: '#666' }}>
              Creating {modalType}...
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CreateItemModal;